<div
  [ngClass]="{ 'pointer-event-none': loderService?.loading }"
  class="position-relative"
>
  <mat-progress-bar
    *ngIf="loderService?.loading"
    color="warn"
    mode="indeterminate"
    class="position-absolute"
  ></mat-progress-bar>
  <div class="login d-flex">
    <div class="container-fluid">
      <section>
        <form class="loginform" id="loginForm" name="loginForm">
          <div class="loginPage">
            <div class="row d-flex">
              <div
                class="col-xl-8 col-lg-8 col-md-12 loginForm order-md-2 position-relative"
              >
                <div class="pre-login-outlet mt-5">
                  <div class="row justify-content-center h-75">
                    <div class="col-md-5 position-relative">
                      <div
                        class="animate__animated animate__fadeInDown animate__slower"
                      >
                        <img
                          alt="tcs logo"
                          [src]="imagesource"
                          class="img-fluid mb-2"
                        />
                        <!--
                      //src="../../../../assets/images/tcs-digigov-white.svg"
                     <dg-file-upload
                      class="dg-file-upload"
                      [title]="''"
                      [profileAttachment]="isProfileComponent"
                      [acceptedType]="profileAcceptedType"
                      [maxSize]="profileMaxSize"
                      [uniqueAttachmentId]="profileUniqueAttachID"
                      [allowFileToAttach]="false"
                      [attachId]="130583355"
                      (finalPath)="onFinalPath($event)"
                      [signatureBox]="true"
                      [refreshAttachComponent]="isRefresh"
                      [defaultImagePath]="'./assets/images/white.png'"
                    >
                    </dg-file-upload> -->
                      </div>
                      <span *ngIf="showEnvDetails"
                        ><app-dg-environment-details></app-dg-environment-details
                      ></span>

                      <router-outlet></router-outlet>
                    </div>
                  </div>
                </div>

                <div
                  class="footer animate__animated animate__fadeIn animate__delay-1s"
                >
                  <dg-footer> </dg-footer>
                </div>
              </div>
              <div
                class="col-lg-4 col-xl-4 col-md-12 ps-md-0 pe-md-0 order-md-1"
              >
                <!--  <div class="flexbox-centering align-items-end ">
                <div class="row align-items-end">
                  
                  <div class="col-md-10">
                    <h2 class="text-white digigov-title mb-0">
                      Most Efficient Workspaces
                    </h2>
                    <p class="text-center text-white ">
                      But I must explain to you how all this mistaken idea of denouncing pleasure
                    </p>
                  </div>
                </div>
              </div> -->

                <div
                  class="dg-login-left-bgc animate__animated animate__fadeIn"
                >
                  <div
                    id="logincarousel"
                    class="carousel slide caption_fullwidth"
                    data-bs-ride="carousel"
                  >
                    <div class="carousel-indicators">
                      <button
                        type="button"
                        data-bs-target="#logincarousel"
                        data-bs-slide-to="0"
                        class="active"
                        aria-current="true"
                        aria-label="Slide 1"
                      ></button>
                      <button
                        type="button"
                        data-bs-target="#logincarousel"
                        data-bs-slide-to="1"
                        aria-label="Slide 2"
                      ></button>
                      <button
                        type="button"
                        data-bs-target="#logincarousel"
                        data-bs-slide-to="2"
                        aria-label="Slide 3"
                      ></button>
                    </div>
                    <div class="carousel-inner">
                      <div class="carousel-item active" data-interval="5000">
                        <img
                          src="../../../assets/images/login-1.png"
                          class="d-block w-100"
                          alt="..."
                        />
                        <div
                          class="carousel-caption d-block animate__animated animate__fadeInUpBig"
                        >
                          <h2 class="text-white digigov-title mb-0">
                            Most Efficient Workspaces
                          </h2>
                          <p class="text-center text-white">
                            But I must explain to you how all this mistaken idea
                            of denouncing pleasure
                          </p>
                        </div>
                      </div>
                      <div class="carousel-item" data-interval="6000">
                        <img
                          src="../../../assets/images/login-2.png"
                          class="d-block w-100"
                          alt="..."
                        />
                        <div
                          class="carousel-caption d-block animate__animated animate__fadeInUpBig"
                        >
                          <h2 class="text-white digigov-title mb-0">
                            Most Efficient Workspaces
                          </h2>
                          <p class="text-center text-white">
                            But I must explain to you how all this mistaken idea
                            of denouncing pleasure
                          </p>
                        </div>
                      </div>
                      <div class="carousel-item" data-interval="5000">
                        <img
                          src="../../../assets/images/login-3.png"
                          class="d-block w-100"
                          alt="..."
                        />
                        <div
                          class="carousel-caption d-block animate__animated animate__fadeInUpBig"
                        >
                          <h2 class="text-white digigov-title mb-0">
                            Most Efficient Workspaces
                          </h2>
                          <p class="text-center text-white">
                            But I must explain to you how all this mistaken idea
                            of denouncing pleasure
                          </p>
                        </div>
                      </div>
                    </div>

                    <button
                      class="carousel-control-prev"
                      type="button"
                      data-bs-target="#logincarousel"
                      data-bs-slide="prev"
                    >
                      <span
                        class="carousel-control-prev-icon"
                        aria-hidden="true"
                      ></span>
                      <span class="visually-hidden">Previous</span>
                    </button>

                    <button
                      class="carousel-control-next"
                      type="button"
                      data-bs-target="#logincarousel"
                      data-bs-slide="next"
                    >
                      <span
                        class="carousel-control-next-icon"
                        aria-hidden="true"
                      ></span>
                      <span class="visually-hidden">Next</span>
                    </button>
                  </div>
                </div>
              </div>

              <!-- Start code for footer -->
            </div>
          </div>
        </form>
      </section>
    </div>
  </div>
</div>
<div [ngClass]="{ loading: loderService?.loading }"></div>
<!-- <div class="footer position-fixed w-100">
  <dg-footer></dg-footer>
</div> -->
